import { cn } from '@/lib/utils';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  as?: keyof HTMLElementTagNameMap;
}

/**
 * Max-width container with responsive horizontal padding.
 * Centers content and constrains width to 1440px.
 */
export function Container({ children, className, as = 'div' }: ContainerProps) {
  const Component = as;
  return (
    <Component className={cn('mx-auto w-full max-w-[1440px] px-5 md:px-10', className)}>
      {children}
    </Component>
  );
}
